module.exports = __webpack_public_path__ + "img/brackets_right_layout_icon.de0001a1.svg";